import { Directive, output, input } from '@angular/core';

export const DatePickerFormControlDirectiveInputs = [
  'showTime',
  'timeOnly',
  'dataType',
  'dateFormat',
  'keepInvalid',
  'fromKey',
  'toKey',
  'minDate',
  'maxDate',
];
export const DatePickerFormControlDirectiveOutputs = ['handleShow'];

@Directive({
  selector: '[uiDatePickerFormControl]',
  standalone: true,
})
export class DatePickerFormControlDirective {
  readonly showTime = input(false);

  readonly timeOnly = input(false);

  readonly dataType = input<'date' | 'dateAsString'>('date');

  readonly dateFormat = input('dd.mm.yy');

  readonly fromKey = input<string>('from');

  readonly toKey = input<string>('to');

  readonly minDate = input<Date | null>(null);

  readonly maxDate = input<Date | null>(null);

  readonly keepInvalid = input(false);

  readonly handleShow = output<void>();
}
